@if (calledFrom === 'contactAdvancedSearch') {
<ng-container [ngComponentOutlet]="activeComponent" [ngComponentOutletInjector]="myInjector"></ng-container>
}

<!-- form panel -->
@if (calledFrom !== 'contactAdvancedSearch') {
<div class="card">
    <div class="card-header">
        Roles
        @if (contactId !== 0 && selectableContactRolesCollection ? selectableContactRolesCollection.length !== 0 : false) {
        <button type="button" class="btn btn-sm btn-primary float-right" title="Add" data-target="#roleOptionsModal" data-toggle="modal">Assign</button>
        }
    </div>
    <div class="card-body">
        <ul class="nav nav-tabs">
            @for (role of roles; track role; let ind = $index) {
                <li class="nav-item" (click)="ldTab(role.component, role.data, ind)">
                    <a class="nav-link" [class.active]="ind === activeTabIndex" id="{{role.data.contactType}}-tab-link" role="tab">
                        {{role.data.name}}
                    </a>
                </li>
            }
        </ul>
        
        <div class="tab-content">
            <div class="tab-pane active show">
                <ng-container [ngComponentOutlet]="activeComponent" [ngComponentOutletInjector]="myInjector"></ng-container>
            </div>
        </div>
    </div>
</div>
}


<!-- modals -->
@if (calledFrom !== 'contactAdvancedSearch') {
<div class="modal fade" id="roleOptionsModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                Select the Role to Assign
            </div>
            <div class="modal-body">
                <h4 class="text-danger w-100 text-center">{{ words[language][ 'addRole' ] }}</h4>
                <ul class="list-group text-dark m-0 p-0">
                    @for (role of selectableContactRolesCollection; track role) {
                    <li class="list-group-item clickable example-box" (click)=addRole(role.key)>
                        {{role.type}}
                    </li>
                    }
                </ul>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" id="close-modal-roleOption">{{ words[language][ 'cancel' ] }}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
}<!-- /.modal -->


@if (calledFrom !== 'contactAdvancedSearch') {
<button type="button" class="d-none" data-target="#deactivateRoleModal" data-toggle="modal" id="deactivateRoleBtn"></button>
}
@if (calledFrom !== 'contactAdvancedSearch') {
<div class="modal fade" id="deactivateRoleModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger h1"></span>
                <h4 class="text-danger w-100 text-center">{{ words[language][ 'deactivate' ] }}</h4>
                <span class="text-muted my-3 text-center">Are you sure you want to deactivate this role?</span>
                <button class="btn btn-danger mt-2 mr-2" (click)="deactivateRole()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{ words[language][ 'yes' ] }}
                </button>
                <button type="button" class="btn btn-secondary mt-2" data-dismiss="modal" id="close-deactivate-modal-role">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
}<!-- /.modal -->